import { addExamListeners } from "../LoadExam/ExamListeners";
import { answers, inputResult, times } from "../Submit/SaveAnswer";
import { displaySolutionTips } from "./SolutionTips";
import { displayStats } from "./Stats";
import { displayTopResultOfTask } from "./TaskStats";
import { handleTimes } from "./Times";
import { transformDrToResult } from "./transformDr";
import { transformFtToResult } from "./transformFt";
import { transformIfToResult } from "./transformIf";
import { transformLaToResult } from "./transformLa";
import { transformMcToResult } from "./transformMc";
import { transformOrToResult } from "./transformOr";
import { transformScToResult } from "./transformSc";
import { transformSfToResult } from "./transformSf";

export const submissionDate:Date = new Date();
export let totalPoints = 0;
export let totalPossible = 0;
export const note = 5;


export function showResults(results:answers, times:times, showNote:string, showTimeAnalysis:string, submissionDate:string){

    const note = showNote == "1";
    const timeAnalysis = showTimeAnalysis == "1";

    handleResults(results);

    changeFormForResults(results, note, submissionDate);

    const url = window.location.pathname;
    if (!url.startsWith('/ab')){
        addExamListeners()
    }

    handleTimes(times, timeAnalysis);

    MathJax.typeset();
}

function changeFormForResults(results:answers, showNote:boolean, submissionDate:string){
    const wrapper = $("#ab-form > .form-wrapper");
    $("#ab-form > .form-wrapper > .top").remove();
    $(".top-hr").remove();
    wrapper.removeClass("form-wrapper").addClass("all-tasks-wrapper");
    $(".tab").show();

    displayStats(showNote, results.points, results.possible, submissionDate);
}


function handleResults(results:answers){
    console.log(results)
    totalPoints = results.points;
    totalPossible = results.possible;

    const tabs = $(".tab");

    tabs.each((ind, tab) => {
         const index = ind + 1;
         const taskId = Number($(tab).attr('data-aufgabe'))
         handleTask($(tab), taskId, results.tasks[taskId], index)   
    })

    // Problem was the order of the tasks
    // let ind = 0;
    // for (const [taskId, resultsItem] of Object.entries(results.tasks)){
    //     ind += 1;
    //     const tab = $(".tab[data-aufgabe=" + taskId + "]");

    //     handleTask(tab, taskId, resultsItem, ind);

    // }
}

function handleTask(tab:JQuery, taskId:number, resultsItem, ind:number){ // hier vlt Fehler?


    const taskPoints = resultsItem.points;
    const taskPossible = resultsItem.possible;


    for (const [inputId, resultItem] of Object.entries(resultsItem.inputs)){
        const input = tab.find(".input[data-id=" + inputId + "]");
        handleInput(input, taskId, inputId, resultItem);
    }

    const html = tab.html();
    const taskStats = displayTopResultOfTask(ind, taskPoints, taskPossible);
    const solutionHtml = displaySolutionTips(resultsItem.solutionText, resultsItem.solutionItems);
    const newHtml = '<div class="form-wrapper">' + taskStats + html + solutionHtml + '</div>'
    tab.html(newHtml);
}


function handleInput(input:JQuery, taskId:number, inputId:number, results:inputResult){
    const inputPoints = results.points;
    const inputPossilbe = results.possible;

    const type = input.attr('data-type');

    
    
    switch(type){
        case "if":
            transformIfToResult(input, results, inputPoints, inputPossilbe)
        break;
        case "mc":
            transformMcToResult(input, results, inputPoints, inputPossilbe)
        break;
        case "sc":
            transformScToResult(input, results, inputPoints, inputPossilbe)
        break;
        case "sf":
            transformSfToResult(input, results, inputPoints, inputPossilbe);
        break;
        case "ft":
            transformFtToResult(input, results, inputPoints, inputPossilbe);
        break;
        case "la":
            transformLaToResult(input, results, inputPoints, inputPossilbe);
        break;
        case "dr":
            transformDrToResult(input, results, inputPoints, inputPossilbe);
        break;
        case "or":
            transformOrToResult(input, results, inputPoints, inputPossilbe);
        break;
    }


}
